// In every file you need this!

// import $ from 'jquery';
// //attach jquery to dom
// window.jQuery = $;
// window.$ = $;

(function($) {
	$(document).ready(function() {
		$(".block .find_out_more_button").on("click", function() {
		    $(".block").removeClass("active");
		    $(".block").addClass("hide");
		    $(this).closest(".block").addClass("active");
		    $(this).closest(".block").removeClass("hide");
		    $(".hidden_inner p").addClass("text-focus-in"); 
		});

		$(".block .close_button").on("click", function() {
		    $(".block").removeClass("active");
		    $(".block").addClass("hide"); 
		    $(".block").removeClass("hide"); 
		});
	});
})(jQuery);